// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBJ8ezVLdlZwxm1MCUmM0kGk6f_AfDjv34",
  authDomain: "gen-lang-client-0052338814.firebaseapp.com",
  projectId: "gen-lang-client-0052338814",
  storageBucket: "gen-lang-client-0052338814.firebasestorage.app",
  messagingSenderId: "773112670287",
  appId: "1:773112670287:web:be8c2ebd46bf1e9930223a"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);